import React, { useState } from 'react'

import { Grid, Paper, Typography } from '@material-ui/core';

import { useTotem } from '../../hooks/useCases/useTotem'
import { ButtonGeneric } from '../atomic/atoms/Buttons';
import { GenericModal } from '../atomic/organisms/GenericModal';

const stylesTeclas = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: '#A178C5',
    color: "#fff",
    fontSize: "1.5em",
    cursor: "pointer",
    padding: "0.5em",
    transition: "background-color 0.3s ease"
};

const stylesTeclasTurno = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: '#A178C5',
    color: "#fff",
    fontSize: "2.5em",
    cursor: "pointer",
    padding: "0.5em",
    transition: "background-color 0.3s ease"
};

const hoverStylesTeclas = {
    backgroundColor: '#7F5A91',
};

export const TurnosOptions = ({ afiliado, setRestartTimer, setConfirmOption, setShowTurnos }) => {
    const totem = useTotem();

    const initialModalValues = {
        open: false,
        value: null
    };

    const [modal, setModal] = useState(initialModalValues);
    const [show, setShow] = useState(false);
    const [subOpciones, setSubOpciones] = useState(null);


    const teclas = totem.data.opciones.map((item) => ({
        id: item.id, descripcion: item.descripcion, mensaje: item.mensaje,
        subOpciones: item.subOpciones,
        recepcion: item.recepcion
    }));

    return (
        <>

            <Grid container spacing={2} justify='center' style={{ margin: "1.5em 0", display: "flex", justifyContent: "center", gap: "1.2em" }}>
                {!show && (
                    [{ descripcion: "MIS TURNOS", turnosDados: true }].map((item, index) => (
                        <Grid
                            key={index}
                            item xs={3}
                            component={Paper}
                            elevation={3}
                            style={stylesTeclasTurno}
                            onMouseOver={e => e.currentTarget.style.backgroundColor = hoverStylesTeclas.backgroundColor}
                            onMouseLeave={e => e.currentTarget.style.backgroundColor = stylesTeclas.backgroundColor}
                            onClick={() => {
                                if (item.turnosDados) {
                                    setShowTurnos();
                                    setRestartTimer();
                                }
                            }}
                        >
                            {item.descripcion}
                        </Grid>
                    ))
                )}
            </Grid>

            <Grid container spacing={2} justify='center' style={{ margin: "1.5em 0", display: "flex", justifyContent: "center", gap: "1.2em" }}>
                {!show ? (
                    [...teclas].map((item, index) => (
                        <Grid
                            key={index}
                            item xs={3}
                            component={Paper}
                            elevation={3}
                            style={stylesTeclas}
                            onMouseOver={e => e.currentTarget.style.backgroundColor = hoverStylesTeclas.backgroundColor}
                            onMouseLeave={e => e.currentTarget.style.backgroundColor = stylesTeclas.backgroundColor}
                            onClick={() => {
                                // if (item.turnosDados) {
                                //     setShowTurnos();
                                //     setRestartTimer();
                                // } else {
                                    if (item.subOpciones.length > 0) {
                                        setSubOpciones({ list: item.subOpciones, idOpcion: item.id });
                                        setShow(true);
                                        setRestartTimer();
                                    } else {
                                        setModal({
                                            open: true,
                                            value: { ...item, idOpcion: item.id, mensaje: item.mensaje, idRecepcion: item.recepcion.id, descripcionRecepcion: item.recepcion.descripcion }
                                        });
                                        setRestartTimer();
                                    }
                                }
                            }
                        >
                            {item.descripcion}
                        </Grid>
                    ))
                ) : (
                    <>
                        {subOpciones && (
                            <SubOptions
                                subOpciones={subOpciones}
                                setShow={setShow}
                                setModal={setModal}
                                setRestartTimer={setRestartTimer}
                            />
                        )}
                    </>
                )}
            </Grid>



            {modal.open && (
                <GenericModal
                    open={modal.open}
                    title={<Typography variant='h4' >{modal.value.descripcion.toUpperCase()}</Typography>}
                    handleClose={() => {
                        setModal(initialModalValues);
                        setRestartTimer();
                    }}
                    textButton="ACEPTAR"
                    handleButton={() => {
                        setConfirmOption({
                            mensaje: modal.value?.mensaje,
                            value: modal.value
                        })
                        totem.insert.solicitudesAfiliado({
                            idAfiliado: afiliado.id_afiliado,
                            idOpcion: modal.value.idOpcion,
                            idSubOpcion: modal.value?.idSubOpcion,
                            idRecepcion: modal.value.idRecepcion
                        });
                        setRestartTimer();
                        setModal(initialModalValues);
                    }}
                    fullWidthButtons
                >
                    <div style={{  textAlign: "center", margin: "0.5em"  }}>
                        <Typography variant='button' style={{  color: "#555", fontSize: "1.5em"  }}>¿Confirmás esta opción?</Typography>
                    </div>
                </GenericModal>
            )}
        </>
    )
}

const SubOptions = ({ subOpciones, setShow, setModal, setRestartTimer }) => {
    const teclas = subOpciones.list.map((item) => ({ id: item.id, descripcion: item.descripcion, mensaje: item.mensaje, recepcion: item.recepcion }));

    return (
        <Grid item xs={11} component={Paper} elevation={2}>
            <ButtonGeneric
                text="VOLVER"
                size="large"
                fullWidth
                onClick={() => {
                    setShow(false);
                    setRestartTimer();
                }}
            />
            <Grid container spacing={2} justify='center' style={{ margin: "1.5em 0", display: "flex", justifyContent: "center", gap: "1.2em" }}>
                {
                    teclas.map((item, index) => (
                        <Grid
                            key={index}
                            item xs={3}
                            component={Paper}
                            elevation={3}
                            style={stylesTeclas}
                            onMouseOver={e => e.currentTarget.style.backgroundColor = hoverStylesTeclas.backgroundColor}
                            onMouseLeave={e => e.currentTarget.style.backgroundColor = stylesTeclas.backgroundColor}
                            onClick={() => {
                                setModal({
                                    open: true,
                                    value: { ...item, idOpcion: subOpciones.idOpcion, idSubOpcion: item.id, mensaje: item.mensaje, idRecepcion: item.recepcion.id },
                                    subOpcion: true
                                });
                                setRestartTimer();
                            }}
                        >
                            {item.descripcion}
                        </Grid>
                    ))
                }
            </Grid>
        </Grid>
    )
}